export const APP_HOST = process.env.REACT_APP_HOST ?? "";
export const APP_API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT ?? "";
export const APP_API_PROJECT_ID = process.env.REACT_APP_API_PROJECT_ID ?? "";
export const APP_API_COLLECTION_ID_ORDERS =
  process.env.REACT_APP_API_COLLECTION_ID_ORDERS ?? "";
export const APP_API_COLLECTION_ID_STASH =
  process.env.REACT_APP_API_COLLECTION_ID_STASH ?? "";
export const APP_API_COLLECTION_ID_ENTRIES =
  process.env.REACT_APP_API_COLLECTION_ID_ENTRIES ?? "";
